import { RealtimeClient } from "./RealtimeClient";
import { RestClient } from "./restClient";

export class DuressService {
	constructor(options) {
		this._options = options;
		this._restClient = new RestClient();
		this._rc = new RealtimeClient();
	}

	/**
	 * activate the duress alarm
	 * @param {function} callback
	 */
	activateDuressAlarm(callback) {
		const url = "/ecosystem/api/duress/activate";
		this._restClient.exec_put(url, null, callback);
	}

	/**
	 * deactivate the duress alarm
	 * @param {function} callback
	 */
	deactivateDuressAlarm(callback) {
		const url = "/ecosystem/api/duress/deactivate";
		this._restClient.exec_put(url, null, callback);
	}

	/**
	 * acknowledge the duress alarm
	 * @param {function} callback
	 */
	ackDuressAlarm(callback) {
		const url = "/ecosystem/api/duress/ack";
		this._restClient.exec_put(url, null, callback);
	}

	/**
	 * Stream duress status
	 * @param {function} callback
	 */
	streamDuressAlarmStatus(callback) {
		const args = {};
		this._rc.subscribe("ecosystem", "/duress", args, function (msg) {
			const response = JSON.parse(msg);
			if (response) {
				callback(null, response);
			}
		});
	}
}
